export default {
  computed: {
    avgSmallPrinters() {
      if (this.getModel.small_printer_burn_rates.length === 0) {
        this.$set(this.getModel, 'bla1', null)
        return ''
      }

      let validBurnRates = 0
      const burnRateSum = this.getModel.small_printer_burn_rates.reduce((sum, burnRate) => {
        if (burnRate.rate > 0) {
          validBurnRates++
          return sum + burnRate.rate
        }
        return sum
      }, 0)

      const burnRate = burnRateSum > 0 ? parseFloat((burnRateSum / 100 / validBurnRates).toFixed(2)) : null

      this.$set(this.getModel, 'bla1', burnRate)

      return burnRate
    },
    avgLargePrinters() {
      if (this.getModel.large_printer_burn_rates.length === 0) {
        this.$set(this.getModel, 'bla2', null)
        return ''
      }

      let validBurnRates = 0
      const burnRateSum = this.getModel.large_printer_burn_rates.reduce((sum, burnRate) => {
        if (burnRate.rate > 0) {
          validBurnRates++
         return sum + burnRate.rate
        }
        return sum
      }, 0)

      const burnRate = burnRateSum > 0 ? parseFloat((burnRateSum / 100 / validBurnRates).toFixed(2)) : null

      this.$set(this.getModel, 'bla2',  burnRate)

      return burnRate
    },
  },
}



// WEBPACK FOOTER //
// ./resources/js/components/trials/avg-burnrate-mixin.js